import React from 'react';
import ResultPageModalButtons from '../../../common/components/redesignComponents/ResultPageComponents/ResultPageModalButtons';
import { safeCapitalizeWords } from '../../../common/constants';

function CondominioModalButtons({
  insuranceRequest,
  processingQuote,
  type,
  riskQuotations,
  removeItemFromCart,
}) {
  const title = type.id === 'res_civile' && insuranceRequest.product.id === 1003
    ? 'Danni ai bene e RC terzi'
    : type.id === 'assistenza' && insuranceRequest.product.id === 1003
      ? 'Assistenza'
      : safeCapitalizeWords(type.name);

  return (
    <ResultPageModalButtons
      insuranceRequest={insuranceRequest}
      processingQuote={processingQuote}
      type={type}
      riskQuotations={riskQuotations}
      removeItemFromCart={removeItemFromCart}
      title={title}
      selectFirstLabel="Danni ai bene e RC terzi"
      excludedCompanyIds={[8]}
    />
  );
}

export default CondominioModalButtons;
